export default __webpack_public_path__ + "static/media/img-0059-usa-half-face.e1267313.png";